import React, { useState, type FormEvent } from 'react';
import styles from './PasswordPrompt.module.css';

interface PasswordPromptProps {
  onSuccess: () => void;
}

const PasswordPrompt: React.FC<PasswordPromptProps> = ({ onSuccess }) => {
  const [password, setPassword] = useState('BAM4Ever');
  const [error, setError] = useState(false);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (password === 'BAM4Ever') {
      sessionStorage.setItem('bam_authenticated', 'true');
      onSuccess();
    } else {
      setError(true);
      setPassword('');
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.prompt}>
        <img 
          src="/BAM-logo-embedded.svg" 
          alt="Book Award Mastery" 
          className={styles.logo}
        />
        <form onSubmit={handleSubmit} className={styles.form}>
          <label htmlFor="password" className={styles.label}>
            Click Submit to Continue
          </label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setError(false);
            }}
            className={styles.input}
            autoFocus
          />
          {error && <p className={styles.error}>Incorrect password</p>}
          <button type="submit" className={styles.button}>
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default PasswordPrompt;
